
import { SettingsIcon, InfoIcon } from 'vue-feather-icons'
import Accordion from /* webpackChunkName: "AccordionSingle" */ "../../components/ui/AccordionSingle";
import AdvancedOptions from /* webpackChunkName: "AdvancedOptions" */ "~/components/file-io/AdvancedOptions";
import FileInput from /* webpackChunkName: "FileInput" */ '~/components/file-io/FileInput';
import { loadSortable } from "~/fc/Helpers/ThumbPreviewHelper";
import { prepareFilesForThumbBasedConversion } from '~/fc/Helpers/ThumbPreviewHelper';

export default {
    name: 'ToolTemplate',
    components: {
        SettingsIcon, InfoIcon,
        FileInput,
        Accordion,
        AdvancedOptions,
        BannerContainer: () => import( /* webpackChunkName: "Banner" */ '~/components/ui/BannerContainer'),
        PreviewLayout: () => import(/* webpackChunkName: "PreviewLayout" */ "./PreviewLayout"),
        ThumbList: () => import(/* webpackChunkName: "ThumbList" */ "~/components/thumb-preview/ThumbList"),
        PageList: () => import(/* webpackChunkName: "PageList" */ "~/components/thumb-preview/PageList"),
        PreviewTemplateAdvancedOption: () => import(/* webpackChunkName: "PreviewTemplateAdvancedOption" */ "~/components/preview/PreviewTemplateAdvancedOption"),
    },
    computed: {
        info() { return this.$store.state.info },
        list() { return this.$store.state.list },
        thumbs() { return this.$store.state.thumb.thumbs },
        hasFiles() { return !!this.$store.state.list.length },
        merging() { return this.$store.state.advancedSetting.merging },
        pageUid() { return this.merging ? 'root' : 'page' },
        customVariables() { return this.info.customVariables },
        enablePreview() { return this.customVariables?.enablePreview || false },
        viewPages() { return this.$store.state.thumb.pdfToolBarOptions.viewPages },
        showPreviewOptions() { return this.info.customVariables?.toolBar },
        selectedPreviewItem() { return this.$store.state.advancedSetting.selectedPreviewItem },
        slug() {
            if (this.merging) return this.merging;
            if (this.info.slug) return this.info.slug;
            return this.info.source.ext + "-to-" + this.info.target.ext;
        },
        pageOptionList() {
            return this.slug && this.$store.state.advancedSetting.perConversionType[this.slug] &&
                this.$store.state.advancedSetting.perConversionType[this.slug].list
                ? this.$store.state.advancedSetting.perConversionType[this.slug].list
                : []
        },
        showAdvancedOptions() {
            // preview is enabled, don't show extra advanced-options
            if (this.enablePreview) { return false }
            if (this.hasFiles) return this.merging
            return this.info.advancedOptions && this.pageOptionList.length
        }
    },
    created() {
        this.$store.commit('updateBreadcrumbs', [{
            url: this.$route.path,
            label: this.info.header_h1
        }])
    },
    mounted() {
        this.initiateTemplate()
    },
    watch: {
        showAdvancedOptions() {
            const element = document.querySelector(
                '[data-automation-id="video_codec_compress"], [data-automation-id="video_codec"]'
            );
            if (element && !element.textContent.includes("GPU")) {
                this.$store.commit("setGpuUpgradeWarning", false);
            }
        },
    },
    methods: {
        initiateTemplate() {
            if (this.info.target) {
                this.$store.dispatch("advancedSetting/setOptions", {
                    slug: this.info.slug,
                    list: this.info.advancedOptions,
                    lang: this.$i18n.locale,
                    targetExt: this.info.target,
                });

                this.$store.dispatch(
                    "advancedSetting/setDefaultTarget",
                    this.info.target
                );
            } else {
                this.$store.dispatch('advancedSetting/setDefaultTarget', '')
            }

            if (this.info.customVariables && this.info.customVariables.forceTarget) this.$store.commit('forceTarget', this.info.target)

            this.preloadScripts()
        },

        async convertFiles() {
            if (!(this.thumbs && this.thumbs.length)) {
                this.$store.commit("setList", this.$refs.thumbList.sortedList);
            }
            else await prepareFilesForThumbBasedConversion(this)

            this.$bus.$emit("NAVIGATE_TO_DOWNLOAD");
        },
        preloadScripts() {
            if (this.customVariables?.enableSort) loadSortable(() => { })
        }
    }
}
